import React from 'react'
import Modal from '../modal/modal'
import './../modal/modal.scss'
import MultiSelect from '../inputs/multi-select'

export default function SectionChangeModal(props) {
  let { open, sectionChangeCloseHandler, moveToNewSection, moduleName, mode } = props

  // Determine heading based on mode
  const heading = mode === 'copy' ? 'Copy Task(s) to Section' : moduleName

  return (
    <Modal
      open={open}
      onClose={sectionChangeCloseHandler}
      fullWidth={true}
      maxWidth='sm'
      modalHeading={heading}
      modalSaveTxt='Yes'
      modalCloseTxt='No'
      onClick={moveToNewSection}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
    >
      <MultiSelect {...props} />
    </Modal>
  )
}
